import VideoControlsFullscreen from './videoControlsFullscreen'

export default VideoControlsFullscreen
